import { render } from "./StaffDatatableFormProfession.vue?vue&type=template&id=3a1e6286"
import script from "./StaffDatatableFormProfession.vue?vue&type=script&lang=js"
export * from "./StaffDatatableFormProfession.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__